import { render, staticRenderFns } from "./ReadjustProposals.vue?vue&type=template&id=47c89436&scoped=true&"
import script from "./ReadjustProposals.vue?vue&type=script&lang=js&"
export * from "./ReadjustProposals.vue?vue&type=script&lang=js&"
import style0 from "./ReadjustProposals.vue?vue&type=style&index=0&id=47c89436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c89436",
  null
  
)

export default component.exports